var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInitLogoTypeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 913.75 500.03",
    style: {
      enableBackground: "new 0 0 913.75 500.03"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7E7E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.84,25.32v107.61h17.58v25.32H-0.53V0h43.96v25.32H25.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.69,17.58v123.08H71.56V17.58H99.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.56,17.58v123.08h-21.1l-47.47-66.81v66.81h-28.13V17.58h21.1l47.47,66.81V17.58H231.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.85,17.58v123.08h-28.13V17.58H294.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.66,44.66h-31.65v96h-28.13v-96h-31.65V17.58h91.43V44.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.95,158.24H432v-25.32h17.58V25.32H432V0h43.96V158.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.36,196.04v123.08H1.23V196.04H29.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.23,196.04v123.08h-21.1L92.66,252.3v66.81H64.52V196.04h21.1l47.47,66.81v-66.81H161.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.52,196.04v123.08h-28.13V196.04H224.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.33,223.11h-31.65v96h-28.13v-96H250.9v-27.08h91.43V223.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.83,196.04v123.08H368.7V196.04H396.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.08,299.78h-45.71l-6.15,19.34h-30.77l41.85-123.08h35.87l41.85,123.08h-30.77L504.08,299.78z  M495.65,273.4l-14.42-45.19l-14.42,45.19H495.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.71,292.04v27.08h-72.09V196.04h28.13v96H637.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M692.21,196.04v123.08h-28.13V196.04H692.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M807.38,292.04v27.08h-84.4v-21.8l47.12-74.2h-46.24v-27.08h82.64v21.8l-47.12,74.2H807.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M913.75,292.04v27.08h-77.36V196.04h76.48v27.08h-48.35v20.4h43.96v26.73h-43.96v21.8H913.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.35,457.83v-83.34h28.13v80.88c0,9.32,4.39,17.23,19.34,17.23s19.34-7.91,19.34-17.23v-80.88h28.13v83.34 c0,26.37-20.4,42.2-47.47,42.2C20.74,500.03,0.35,484.21,0.35,457.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.28,374.49v123.08h-21.1l-47.47-66.81v66.81h-28.13V374.49h21.1l47.47,66.81v-66.81H226.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.53,470.49v27.08h-72.09V374.49h28.13v96H333.53z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitLogoTypeWhite);
export default __webpack_public_path__ + "static/media/INIT_Logo Type_White.d58f5443fefe71658f8488492929d67c.svg";
export { ForwardRef as ReactComponent };